module.exports = __webpack_public_path__ + "img/btn-new-banner-l.60e14d4e.svg";